module.exports = __webpack_public_path__ + "img/home_slider_19.dd7253e2.jpg";